export const userRegistrationPreCheck = {
    title: 'IBAアプリ ユーザ登録',
    selectPlaceholder: '選択してください',
    purposeOfUse: 'アプリ利用目的',
    purposeOfUseOptions: {
        proposal: '提案活動',
        consulting: 'コンサルデリバリー',
        marketing: 'マーケティング活動',
        selfImprovement: '自己研鑽',
        training: '研修',
        development: '開発・テスト',
        others: 'その他'
    },
    applicationStatus: 'IBA利用申請状況',
    applicationStatusOptions: {
        applied: '申請済み',
        notApplied: '未申請'
    },
    assuranceBusiness: '業務利用確認',
    assuranceBusinessDescription: 'IBAをAssurance業務に用いますか？',
    assuranceBusinessOptions: {
        yes: 'はい',
        no: 'いいえ'
    },
    isqm1: 'ISQM1に関連する業務に利用しますか？',
    isqm1Description:
        'AssuranceのアンダーでConsがIBAを利用するケースにおいて、ISQM1に関連する業務には利用不可です。IBAをAssurance業務に用いる場合、ISQM1に関連する業務に利用しますか？',
    isqm1Options: {
        yes: 'はい',
        no: 'いいえ'
    },
    submit: '次へ',
    errorRequired: '必須項目です',
    errorNotApplied: 'IBA利用申請が必要です。申請後に再度登録してください。',
    errorIsqm1: 'ISQM1に関連する業務にはIBAを利用できません。',
    applicationFormLink: '申請フォームはこちら'
}
